import { render } from "./theme32.vue?vue&type=template&id=45c575d6&scoped=true"
import script from "./theme32.vue?vue&type=script&lang=js"
export * from "./theme32.vue?vue&type=script&lang=js"

import "./theme32.vue?vue&type=style&index=0&id=45c575d6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-45c575d6"

export default script